var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#9AAAB4","d":"M27.388 24.642L24.56 27.47l-4.95-4.95l2.828-2.828z","key":0}),React.createElement("path",{"fill":"#66757F","d":"M34.683 29.11l-5.879-5.879a2 2 0 0 0-2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l5.879 5.879a4 4 0 1 0 5.656-5.656z","key":1}),React.createElement("circle",{"fill":"#8899A6","cx":"13.586","cy":"13.669","r":"13.5","key":2}),React.createElement("circle",{"fill":"#BBDDF5","cx":"13.586","cy":"13.669","r":"9.5","key":3}),React.createElement("rect",{"x":"0","y":"0","width":"36","height":"36","fill":"rgba(0, 0, 0, 0)","key":4})]);
}

SearchIcon.defaultProps = {"aria-hidden":"true","focusable":"false","width":"1em","height":"1em","style":{"msTransform":"rotate(360deg)","WebkitTransform":"rotate(360deg)","transform":"rotate(360deg)"},"preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 36 36"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
